import Vue from "vue";
/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
  faSun,
  faArrowRightArrowLeft,
  faMagnifyingGlass,
  faRotate,
  faUpDownLeftRight,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faRotateLeft,
  faRotateRight,
  faArrowsUpDown,
  faArrowsLeftRight,
  faMinus,
  faPlus,
  faFileImage,
  faPhone,
  faMessage,
  faCircleCheck
} from "@fortawesome/free-solid-svg-icons";

/* add icons to the library */
library.add(
  faSun,
  faArrowRightArrowLeft,
  faMagnifyingGlass,
  faRotate,
  faUpDownLeftRight,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faRotateLeft,
  faRotateRight,
  faArrowsUpDown,
  faArrowsLeftRight,
  faMinus,
  faPlus,
  faFileImage,
  faPhone,
  faMessage,
  faCircleCheck
);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);



// WEBPACK FOOTER //
// ./src/js/fontAwesomeHelper.js